/**
 * NEXUMA — Llojet e shablloneve
 *
 * Regjistri i vetëm i llojeve: kontrata, vendim, vërejtje. Ekziston sepse të
 * njëjtat panele shfaqen në dy vende — te tabi "Shabllonet" i Konfigurimit
 * (aty ku shkon njeriu t'i kërkojë) dhe te faqja `/templates` (ku çojnë lidhjet
 * e vjetra). Regjistri i mban të dyja anët të njëjta; shto lloj të ri KËTU dhe
 * del vetvetiu në të dyja.
 */
import React from 'react';
import ArticleIcon from '@mui/icons-material/Article';
import GavelIcon from '@mui/icons-material/Gavel';
import ReportProblemIcon from '@mui/icons-material/ReportProblemOutlined';
import TemplateList from '../contracts-templates/TemplateList';
import DecisionTemplates from './DecisionTemplates';
import WarningTemplates from './WarningTemplates';

export const TEMPLATE_KINDS = [
  { key: 'kontratat', label: 'Kontratat', icon: <ArticleIcon sx={{ fontSize: 17 }} />,       Panel: TemplateList },
  { key: 'vendimet',  label: 'Vendimet',  icon: <GavelIcon sx={{ fontSize: 17 }} />,         Panel: DecisionTemplates },
  { key: 'verejtjet', label: 'Vërejtjet', icon: <ReportProblemIcon sx={{ fontSize: 17 }} />, Panel: WarningTemplates },
];

/** Indeksi i llojit sipas slug-ut; 0 (kontratat) kur slug-u mungon a s'njihet. */
export const kindIndex = (slug) =>
  Math.max(0, TEMPLATE_KINDS.findIndex((k) => k.key === (slug || '').trim().toLowerCase()));
